import gql from 'graphql-tag'

export default gql`
  query getEducation($id: String!) {
    getExpert(id: $id) {
      id
      education {
        id
        degree
        endDate
        major
        schoolName
        startDate
      }
      certificates
      languages

      onboardingStep
    }
  }
`
